import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem, Chip } from "@kuda/ui";
import { CloudIcon } from "@kuda/ui/icons";
import { config } from "./config";

const AwsProfileSelector = ({ selectedProfile, onProfileChange, platformName }) => {
  // Only show for AWS platform
  if (platformName !== config.platforms[0]) {
    return null;
  }

  const current = config.awsProfiles[selectedProfile || 'profile-a'];

  return (
    <div className="flex flex-col gap-1.5 mt-1" style={{ minWidth: 220 }}>
      <Select value={selectedProfile || 'profile-a'} onValueChange={onProfileChange}>
        <SelectTrigger>
          <div className="flex items-center gap-2">
            <CloudIcon className="size-4 text-color-icon-brand-primary-default" />
            <SelectValue placeholder="AWS Profile">{current?.name}</SelectValue>
          </div>
        </SelectTrigger>
        <SelectContent>
          {Object.entries(config.awsProfiles).map(([key, profile]) => (
            <SelectItem key={key} value={key}>
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">{profile.name}</span>
                  <Chip label={profile.region} size="sm" type="selectable" selected={false} />
                </div>
                <span className="text-xs text-color-text-secondary">{profile.description}</span>
                <span className="text-xs text-color-text-tertiary">Account: {profile.account}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default AwsProfileSelector;
